"use client";

import { useEffect } from "react";
import Link from "next/link";

export default function AuthError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Auth error:", error);
  }, [error]);

  return (
    <div className="flex items-center justify-center min-h-screen px-4">
      <div className="text-center max-w-sm">
        <h2 className="text-xl font-bold mb-2">Authentication Error</h2>
        <p className="text-sm text-muted-foreground mb-6">
          Something went wrong. Please try again.
        </p>
        <div className="flex items-center justify-center gap-3">
          <button onClick={reset} className="h-9 px-4 rounded-lg bg-primary text-primary-foreground text-sm font-medium hover:bg-primary/90">
            Try Again
          </button>
          <Link href="/login" className="h-9 px-4 rounded-lg border text-sm font-medium hover:bg-muted inline-flex items-center">
            Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
}
